/**
 *  Author(s) : Shakthi Priya.
 * Prupose : Function to open a link in new tab.
 */
const openLink = (link) => {
  const newWindow = window.open(link, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};

export default openLink;
